import { SoundEnum } from "src/app/enums/sound.enum";
import { TranslateService } from "@ngstack/translate";
import { FormGroup, FormBuilder } from "@angular/forms";
import { Component, OnInit, Inject, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatSelect, MatDialogRef, MatOption } from "@angular/material";

import { IBranch } from "src/app/interfaces/branch";
import { ICompany } from "src/app/interfaces/company";
import { CIDService } from "src/app/services/common/cid.service";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { BranchService } from "src/app/services/http/business/branch/branch.service";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { PackageEducationBranchService } from "src/app/services/http/business/packageEducationBranch/package-education-branch.service";
//import { initDomAdapter } from "@angular/platform-browser/src/browser";

@Component({
  selector: "app-add-level-to-package",
  templateUrl: "./add-level-to-package.component.html",
  styleUrls: ["./add-level-to-package.component.css"]
})
export class AddLevelToPackageComponent implements OnInit {
  form: FormGroup;
  branchList: IBranch[];
  companyList: ICompany[];
  activeBranch: any[];
  constructor(
    private fb: FormBuilder,
    private cideService: CIDService,
    public translate: TranslateService,
    private btanchService: BranchService,
    private companyService: CompanyService,
    private snackBarService: SnackBarService,
    private dialogRef: MatDialogRef<AddLevelToPackageComponent>,
    private packageEducationBranchService: PackageEducationBranchService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }
  @ViewChild('allSelected') private allSelected: MatOption;
  ngOnInit() {
    console.log(this.data);
    this.companyService.list(0, 0).subscribe(res => {
      this.companyList = res.DataList;
    });
    this.createForm();
    //this.getActiveBranch();
  }

  createForm() {
    this.form = this.fb.group({
      EducationPackageId: [this.data.packageId],
      BranchEncryptList: [this.data.branchEncryptList]
    });
    //console.log(this.getActiveBranch())
  }

  getBranches(e: MatSelect) {
    this.cideService.setCID(e.value);
    let JustActiveBranch=true;
    this.btanchService.list(JustActiveBranch,0, 0).subscribe(res => {
      this.form.value.BranchEncryptList = this.data.branchEncryptList;
      this.branchList = res.DataList;
    });
  }
  tosslePerOne() : Boolean{ 
    if (this.allSelected.selected) {  
     this.allSelected.deselect();
     return false;
 }
   if(this.form.controls.BranchEncryptList.value.length==this.branchList.length)
     this.allSelected.select();
 
 }
  toggleAllSelection() {
   
    if (this.allSelected.selected) {
      this.form.controls.BranchEncryptList
        .patchValue([...this.branchList.map(item => item.BranchEncryptId), 0]);
    } else {
      this.removedItemsThatBeforeSelected(this.form.controls.BranchEncryptList.value,false);
    }
  }

  removedItemsThatBeforeSelected(data : any,final : boolean){
    let branchEncrypts:any[]=data;
    this.branchList.forEach(element => {
      console.log(this.branchList);
        let isActive=branchEncrypts.some(id => id == this.isActive(element.BranchEncryptId));
       if (!isActive && !final) 
          branchEncrypts.splice(branchEncrypts.indexOf(element.BranchEncryptId), 1);
        
      else if (isActive && final) 
          branchEncrypts.splice(branchEncrypts.indexOf(element.BranchEncryptId), 1);
    });
    this.form.controls.BranchEncryptList
      .patchValue(branchEncrypts);
  }

  isActive(branch: any) {
    return this.data.branchEncryptList.find(item => item == branch);
  }

  submit(data) {
    const temp=data.BranchEncryptList.find(x => x == 0);
    if (temp || temp==0) {
      data.BranchEncryptList.splice(data.BranchEncryptList.indexOf(temp), 1);
    }
      
    this.removedItemsThatBeforeSelected(data.BranchEncryptList,true);
    this.packageEducationBranchService.add(data).subscribe(() => {
      this.onNoClick();
      this.snackBarService.OpenSnackBar(
        this.translate.get("success.assignPackageToBranches"),
        "ok",
        5000,
        SoundEnum.beep
      );
    });
  }

  onNoClick() {
    this.dialogRef.close();
  }

}
